export default __webpack_public_path__ + "static/media/clover-leaf.272b2694.svg";